require('cropperjs/dist/cropper.css');
require('./avatarEditorModal.scss');

// @ vendor
const Cropper = require('react-cropper').default;
const PropTypes = require('prop-types');
const React = require('react');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ components
const UploadImageButton = require('components/myProfile/uploadImageButton/uploadImageButton');
// @ constants
const { PROFILE_AVATAR_IMAGE_MAX_UPLOAD_PIXELS } = require('constants/index');

class AvatarEditorModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleCropImage = this.handleCropImage.bind(this);
        this.handleRotateClockwise = this.handleRotateImage.bind(this, true);
        this.handleRotateCounterClockwise = this.handleRotateImage.bind(this, false);
    }

    handleCropImage() {
        const { onAvatarChange, onChangeModal } = this.props;
        const options = {
            height: PROFILE_AVATAR_IMAGE_MAX_UPLOAD_PIXELS,
            width: PROFILE_AVATAR_IMAGE_MAX_UPLOAD_PIXELS
        }
        const croppedCanvas = this.cropper.getCroppedCanvas(options);
        if (croppedCanvas) {
            const newFile = {
                file: croppedCanvas,
                imgUrl: croppedCanvas.toDataURL()
            };
            onAvatarChange(newFile);
            onChangeModal();
        }
    }

    handleRotateImage(clockwise) {
        const angle = clockwise ? 90 : -90;
        this.cropper.rotate(angle);
    }

    render() {
        const {
            onChangeModal,
            openModal,
            setImageUrl,
            setProfileAvatarEditorError,
            uplodadedAvatar
        } = this.props;

        const content = (
            <div className="row">
                <div className="avatar-editor-modal__body">
                    <div className="col-xs-7">
                        <div className="img-container">
                            <Cropper
                                aspectRatio="1"
                                autoCropArea="1"
                                center={true}
                                className="avatar-editor-modal__cropper"
                                dragMode="move"
                                guides={false}
                                minCropBoxHeight="100"
                                minCropBoxWidth="100"
                                ref={cropper => { this.cropper = cropper; }}
                                responsive={true}
                                scalable={true}
                                src={uplodadedAvatar}
                                viewMode="1"
                                zoomable={false}
                            />
                        </div>
                    </div>
                    <div className="col-xs-5 avatar-editor-modal__options-container">
                        <div>
                            <OKButton modifier="task" onClick={this.handleRotateCounterClockwise}>
                                <i className="icon-rotar-imagen" />
                            </OKButton>
                            <div className="avatar-editor-modal__second-icon-inverted">
                                <OKButton modifier="task" onClick={this.handleRotateClockwise}>
                                    <i className="icon-rotar-imagen" />
                                </OKButton>
                            </div>
                        </div>
                        <div className="avatar-editor-modal__upload-button">
                            <UploadImageButton
                                label="avatarPicker-uploadAnotherImageButtonLabel"
                                setImageUrl={setImageUrl}
                                setProfileAvatarEditorError={setProfileAvatarEditorError}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <OKModal
                respectModalContent
                content={content}
                footerType="navigation"
                isOpen={openModal}
                onCloseCallback={onChangeModal}
                onPrimaryButtonClick={this.handleCropImage}
                onSecondaryButtonClick={onChangeModal}
                primaryButtonText="profile-avatarEditorModalButtonConfirm"
                secondaryButtonText="profile-avatarEditorModalButtonCancel"
                title="profile-avatarEditorModalTitle"
                contentOverflow="visible"
                overlayClassName="avatar-editor-modal-content"
            />
        );
    }
}

AvatarEditorModal.defaultProps = {
    openModal: false
};

AvatarEditorModal.propTypes = {
    onAvatarChange: PropTypes.func.isRequired,
    onChangeModal: PropTypes.func.isRequired,
    openModal: PropTypes.bool.isRequired,
    setProfileAvatarEditorError: PropTypes.func.isRequired,
    setImageUrl: PropTypes.func.isRequired,
    uplodadedAvatar: PropTypes.string
};

module.exports = AvatarEditorModal;
